import { createContext, useContext } from 'react';

// ---------------------------------------------------------------------------
// Shared context for variable node metadata
// Consumed by EcaVariableNode and NodeConfigPanel via useVariables()
// ---------------------------------------------------------------------------

export const VariablesCtx = createContext({
  variables: {},
  updateVariable: () => {},
  duplicateVarRef: () => {},
  deleteVarRef: () => {},
  deleteVariable: () => {},
});

export const useVariables = () => useContext(VariablesCtx);

// ---------------------------------------------------------------------------
// Color palette — auto-assigned from varId hash
// ---------------------------------------------------------------------------

export const VAR_PALETTE = [
  '#8B5CF6', // violet
  '#EC4899', // pink
  '#F59E0B', // amber
  '#EF4444', // red
  '#14B8A6', // teal
  '#F97316', // orange
  '#06B6D4', // cyan
  '#84CC16', // lime
];

/** Deterministically maps a varId to a palette color. */
export const varIdToColor = (varId) => {
  const hash = varId.split('').reduce((acc, c) => acc + c.charCodeAt(0), 0);
  return VAR_PALETTE[hash % VAR_PALETTE.length];
};

/** Generates a unique variable ID: `_var_` + 6 random alphanumeric chars. */
export const genVarId = () => {
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let id = '_var_';
  for (let i = 0; i < 6; i++) id += chars[Math.floor(Math.random() * chars.length)];
  return id;
};
